module.exports = __webpack_public_path__ + "img/2.d0cb5cc4.jpg";